import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { MenuView } from 'Store/User/reducer';
import { setMenuView } from 'Store/User/actions';
import { fetchLogout } from 'Store/User/thunks';
import UserInfo from './UserInfo/UserInfo';
import MenuUser from 'Components/MenuUser/MenuUser';
import Spinner from 'Components/Shared/Spinner/Spinner';
import FormLoginContainer from 'Components/FormLogin/FormLoginContainer';
import FormAccountContainer from 'Components/FormAccount/FormAccountContainer';
import FetchFailureMessage from 'Components/Shared/FetchFailureMessage/FetchFailureMessage';
import LanguagePicker from 'Components/Shared/LanguagePicker/LanguagePicker';

import { 
  getLoggedInUser, 
  getIsLoggedIn, 
  getMenuView, 
  getIsFetchingUser,
  getMenuError,
} from 'Store/User/selectors';

interface IProps {
  isVisible: boolean;
  onClose: () => void;
}

interface IPropsInternal {
  isLoggedIn: boolean;
  isFetching: boolean;
  menuView: MenuView;
  menuError: string;
  loggedInUser: Julius.Website.CustomerInfoViewModel;
  fetchLogout: () => void;
  fetchCurrentUser: () => void;
  setMenuView: (accountStatus: MenuView) => void;
}

type Props = IProps & IPropsInternal & RouteComponentProps<{}>;

class MenuUserContainer extends React.PureComponent<Props> {

  onBack = () => {
    const menuView = this.props.isLoggedIn ? 
      MenuView.INFO : MenuView.LOGIN;
    this.props.setMenuView(menuView);
  }

  onLogout = () => {
    this.props.fetchLogout();
  }

  onCreateAccount = () => {
    this.props.setMenuView(MenuView.CREATE_ACCOUNT);
  }

  onUpdateAccount = () => {
    this.props.setMenuView(MenuView.UPDATE_ACCOUNT);
  }

  onUpdatePassword = () => {
    this.props.setMenuView(MenuView.UPDATE_PASSWORD);
  }

  onGoToTickets = () => {
    this.redirectToTicketsPage();
  }

  redirectToTicketsPage = () => {
    const { history } = this.props;
    history.push('/bokningar');
  }

  render() {
    const { isFetching, menuView } = this.props;

    if (isFetching) {
      return (
        <MenuUser
          isVisible={ this.props.isVisible }
          onClose={ this.props.onClose }
        >
          <Spinner />
        </MenuUser>
      );
    }
    
    switch (menuView) {
      case MenuView.LOGIN:
        return (
          <MenuUser
            isVisible={ this.props.isVisible }
            onClose={ this.props.onClose }
          >
            <FormLoginContainer {
              ... { 
                showCreateOption: true, 
                onCreateAccount: this.onCreateAccount, 
              } 
            } />
            <LanguagePicker />
          </MenuUser> 
        );

      case MenuView.INFO:
        return (
          <MenuUser
            isVisible={ this.props.isVisible }
            onClose={ this.props.onClose }
          >
            <UserInfo
              userInfo={ this.props.loggedInUser }
              onLogout={ this.onLogout }
              onUpdateAccount={ this.onUpdateAccount }
              onUpdatePassword={ this.onUpdatePassword }
              onGoToTickets={ this.onGoToTickets }
            />
            <LanguagePicker />
          </MenuUser>
        );

      case MenuView.ACTION_FAILED:

        const { menuError } = this.props;

        return (
          <MenuUser
            isVisible={ this.props.isVisible }
            onClose={ this.props.onClose }
            onBack={ this.onBack }
          >
            { menuError && menuError.length ?
              menuError : <FetchFailureMessage />
            }
            <LanguagePicker />  
          </MenuUser>
        );
  
      default:
        return (
          <MenuUser
            isVisible={ this.props.isVisible }
            onClose={ this.props.onClose }
            onBack={ this.onBack }
          >
            <FormAccountContainer />
            <LanguagePicker />
          </MenuUser>
        );
    }
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetchingUser(state),
    isLoggedIn: getIsLoggedIn(state),
    loggedInUser: getLoggedInUser(state),
    menuView: getMenuView(state),
    menuError: getMenuError(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchLogout,
    setMenuView,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(MenuUserContainer);


// WEBPACK FOOTER //
// ./src/components/MenuUser/MenuUserContainer.tsx